export default import.meta.ROLLDOWN_FILE_URL_buX_bUDtjhxkXwpG$r4caQ